var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"competence-link",attrs:{"to":_vm.to}},[_c('div',{staticClass:"competence-icon",class:_vm.competenceType === 'soft' ? 'soft-icon' : 'hard-icon'}),_c('div',{staticClass:"competence-name"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }